/** The analytics event vocabulary, named once.
 *
 * `track()` (lib/analytics.ts) forwards these to the host's Segment-style
 * `window.analytics`. Two of them keep the *exact* legacy signup-form-lib
 * strings so the dashboards those already feed (Segment/Hex) keep matching once
 * this flow replaces it — do not reformat them. Everything else is the new
 * `OTP …` Title Case vocabulary. See docs/development.md for the reconciliation.
 */

/** Verbatim legacy signup-form-lib names — kept for downstream parity. */
export const LEGACY = {
  /** New account created — a live conversion metric downstream. */
  SIGN_UP_SUCCESS: "Sign up success",
  /** The one signup failure legacy tracked (server 500 only). */
  SIGN_UP_FORM_500_ERROR: "Sign up form 500 error",
} as const;

/** The new mba-id vocabulary. */
export const OTP = {
  WIDGET_OPENED: "OTP Widget Opened",
  WIDGET_CLOSED: "OTP Widget Closed",
  SOCIAL_CLICKED: "OTP Social Clicked",
  EMAIL_SUBMITTED: "OTP Email Submitted",
  /** The address never left the browser: it isn't one. Separate from
   * EMAIL_SUBMIT_FAILED so a rise in typos doesn't read as the edge failing. */
  EMAIL_INVALID: "OTP Email Invalid",
  EMAIL_SUBMIT_FAILED: "OTP Email Submit Failed",
  CODE_VERIFIED: "OTP Code Verified",
  CODE_VERIFY_FAILED: "OTP Code Verify Failed",
  DIFFERENT_EMAIL_CLICKED: "OTP Different Email Clicked",
  PASSWORD_FALLBACK_OFFERED: "OTP Password Fallback Offered",
  PASSWORD_SIGNIN: "OTP Password Signin",
  PASSWORD_SIGNIN_FAILED: "OTP Password Signin Failed",
  SIGNUP_FAILED: "OTP Signup Failed",
  LOGIN_SUCCESS: "OTP Login Success",
  CONSENT_SHOWN: "OTP Consent Shown",
  CONSENT_SET: "OTP Consent Set",
  /** A consent write that did not land. Pairs with CONSENT_SET so the funnel
   * reads Shown → Set | Save Failed, and a silently dropped opt-in shows up as
   * a gap instead of nothing at all (it once did — see consentCapture.ts). */
  CONSENT_SAVE_FAILED: "OTP Consent Save Failed",
  LOGGED_OUT: "OTP Logged Out",
} as const;
